import React, { useState, useEffect, useCallback } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moneda from '../moneda';
import Swal from 'sweetalert2';
import contador from '../contador';
import MiPedido from '../MiPedido/MiPedido';
import { getConfig } from '../../utils/configService';

export default function Cart() {
    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [modalIsOpen3, setModalIsOpen3] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [noteText, setNoteText] = useState('');
    const [name, setName] = useState('');
    const [codigo, setCodigo] = useState('');
    const [contactos, setContactos] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('efectivo');
    const [deliveryOption, setDeliveryOption] = useState('delivery');

    const fetchCartItems = useCallback(() => {
        const cart = JSON.parse(localStorage.getItem('cart')) || [];
        if (productos.length === 0) {
            // Si aún no se cargaron los productos, mantenemos los items básicos
            setCartItems(cart);
            setLoading(false);
            return;
        }
        const items = cart.map((cartItem) => {
            const producto = productos.find(p => p.idProducto === cartItem.idProducto);
            return {
                ...producto,
                idProducto: cartItem.idProducto,
                cantidad: cartItem.cantidad,
                item: cartItem.item,
            };
        });
        setCartItems(items);
        setLoading(false);
    }, [productos]);

    useEffect(() => {
        cargarContacto();
        cargarMesas();
    }, []);

    useEffect(() => {
        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            const precio = Number(item.precio) || 0;
            const cant = Number(item.cantidad) || 0;
            totalPriceCalc += precio * cant;
        });
        setTotalPrice(totalPriceCalc);
    }, [cartItems]);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto?.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    useEffect(() => {
        cargarProductos();
    }, [isFocused]);

    useEffect(() => {
        fetchCartItems();
    }, [fetchCartItems, isFocused]);

    // Escuchar actualizaciones del carrito desde cualquier parte (p. ej. agregar desde el listado)
    useEffect(() => {
        const handleCartChange = () => {
            fetchCartItems();
        };

        window.addEventListener('cartUpdated', handleCartChange);
        window.addEventListener('storage', handleCartChange);

        return () => {
            window.removeEventListener('cartUpdated', handleCartChange);
            window.removeEventListener('storage', handleCartChange);
        };
    }, [fetchCartItems]);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const obtenerImagen = (item) => {
        return item?.imagen1 || item?.imagen2 || item?.imagen3 || item?.imagen4 || null;
    };

    const openModal = () => {
        setModalIsOpen(true);
        setIsFocused(true);
        cargarMesas();
        fetchCartItems();
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
    };

    const openModal2 = () => {
        setModalIsOpen2(true);
    };

    const closeModal2 = () => {
        setModalIsOpen2(false);
    };
    const openModal3 = () => {
        const guardada = localStorage.getItem('mesaActiva');
        if (guardada) {
            try {
                const parsed = JSON.parse(guardada);
                if (parsed && parsed.idMesa) setIdMesa(parsed.idMesa);
            } catch(e){}
        }
        setModalIsOpen3(true);
    };

    const closeModal3 = () => {
        setModalIsOpen3(false);
    };

    const removeFromCart = (id) => {
        const updatedCart = cartItems.filter(item => item.idProducto !== id);
        setCartItems(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart.map(i => ({ idProducto: i.idProducto, cantidad: i.cantidad, item: i.item }))));
        window.dispatchEvent(new Event('cartUpdated'));
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem('cart');
        window.dispatchEvent(new Event('cartUpdated'));
    };

    const [codigos, setCodigos] = useState([]);

    useEffect(() => {
        cargarCodigos();
    }, []);

    const cargarCodigos = () => {
        fetch(`${baseURL}/codigosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCodigos(data.codigos || []);
            })
            .catch(error => console.error('Error al cargar códigos:', error));
    };

    const handleWhatsappMessage = () => {
        const codigoDescuento = codigos.find(item => item.codigo === codigo);
        let descuentoActualizado = 0;

        if (codigoDescuento) {
            descuentoActualizado = codigoDescuento.descuento;
        }

        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            const precio = Number(item.precio) || 0;
            const cant = Number(item.cantidad) || 0;
            totalPriceCalc += precio * cant;
        });

        // Aplicar descuento y asegurarse de que el precio no sea negativo
        let totalPriceWithDiscount = totalPriceCalc - descuentoActualizado;
        if (totalPriceWithDiscount < 0) {
            totalPriceWithDiscount = 0;
        }

        const formattedTotalPrice = totalPriceWithDiscount.toFixed(2);

        // 1. Obtener número de WhatsApp de Pedidos configurado en la sección de Configuraciones
        const sysConfig = getConfig();
        const configuredPedidosPhone = sysConfig.whatsappPedidos ? sysConfig.whatsappPedidos.replace(/\D/g, '') : null;
        const fallbackPhone = contactos?.telefono ? String(contactos.telefono).replace(/\D/g, '') : '';
        const phoneNumber = configuredPedidosPhone || fallbackPhone;

        const cartDetails = cartItems.map((item) => (
            `\n*${item.titulo || 'Producto'}*\nCantidad: ${item.cantidad} \n${item?.item || ''}\nPrecio: ${moneda} ${item.precio || 0}\n`
        ));

        let noteMessage = '';

        if (name.trim() !== '') {
            noteMessage += `\nNombre: ${name}`;
        }

        if (noteText.trim() !== '') {
            noteMessage += `\nNota: ${noteText}`;
        }
        if (codigo.trim() !== '') {
            noteMessage += `\nCupón : ${codigo}\nDescuento de : ${moneda} ${descuentoActualizado}`;
        }

        const paymentMessage = paymentMethod === 'efectivo' ? 'Pago en efectivo' : 'Pago por transferencia bancaria';
        const paymentMessage2 = deliveryOption === 'delivery' ? 'Envio a domicilio' : 'Retiro personalmente';

        const message = `¡Hola! 🌟 Estoy interesado en encargar:\n${cartDetails.join('')}\n------------------------------------>\n ${noteMessage}\n${paymentMessage2}\n${paymentMessage}\n\n------------------------------------>\n\n*Total: ${moneda} ${formattedTotalPrice}*`;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, '_blank');
        setName('');
        setNoteText('');
        setCodigo('');
        setModalIsOpen(false);
        setModalIsOpen2(false);
    };

    // Función para aumentar la cantidad de un producto en el carrito
    const increaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        updatedCartItems[index].cantidad += 1;
        setCartItems(updatedCartItems);
        localStorage.setItem('cart', JSON.stringify(updatedCartItems.map(i => ({ idProducto: i.idProducto, cantidad: i.cantidad, item: i.item }))));
        window.dispatchEvent(new Event('cartUpdated'));
    };

    // Función para disminuir la cantidad de un producto en el carrito
    const decreaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        if (updatedCartItems[index].cantidad > 1) {
            updatedCartItems[index].cantidad -= 1;
            setCartItems(updatedCartItems);
            localStorage.setItem('cart', JSON.stringify(updatedCartItems.map(i => ({ idProducto: i.idProducto, cantidad: i.cantidad, item: i.item }))));
            window.dispatchEvent(new Event('cartUpdated'));
        }
    };

    /* realizar pedidos mesa ------------------------*/
    const [mesas, setMesas] = useState([]);
    const [idMesa, setIdMesa] = useState('');
    const estado = 'Pendiente';

    const [mensaje, setMensaje] = useState('');
    const [selectedMesa] = useState('');
    const [mesaActivaCliente, setMesaActivaCliente] = useState(null);

    useEffect(() => {
        const checkMesaActiva = () => {
            const guardada = localStorage.getItem('mesaActiva');
            if (guardada) {
                try {
                    const parsed = JSON.parse(guardada);
                    if (parsed && parsed.idMesa) {
                        setMesaActivaCliente(parsed);
                        setIdMesa(parsed.idMesa);
                    }
                } catch (e) {}
            } else {
                setMesaActivaCliente(null);
            }
        };
        checkMesaActiva();
        window.addEventListener('mesaActivaUpdated', checkMesaActiva);
        window.addEventListener('storage', checkMesaActiva);
        return () => {
            window.removeEventListener('mesaActivaUpdated', checkMesaActiva);
            window.removeEventListener('storage', checkMesaActiva);
        };
    }, []);

    const cargarMesas = () => {
        fetch(`${baseURL}/mesaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setMesas(data.mesas || []);
            })
            .catch(error => console.error('Error al cargar mesas:', error));
    };

    const crearPedido = async () => {
        setMensaje('Procesando...');

        try {
            const productosPedido = cartItems.map(item => {
                return {
                    titulo: item.titulo,
                    cantidad: item.cantidad,
                    item: item.item,
                    categoria: item.categoria,
                    precio: item.precio,
                    imagen: obtenerImagen(item)
                };
            });
            const productosPedidoJSON = JSON.stringify(productosPedido);

            let totalPriceCalc = 0;
            cartItems.forEach(item => {
                totalPriceCalc += (Number(item.precio) || 0) * (Number(item.cantidad) || 0);
            });

            const codigoDescuento = codigos.find(item => item.codigo === codigo);
            let descuentoCodigo = 0;

            if (codigoDescuento) {
                descuentoCodigo = codigoDescuento.descuento;
            }

            const totalPriceWithDiscount = totalPriceCalc - descuentoCodigo;

            const formData = new FormData();
            formData.append('idMesa', idMesa);
            formData.append('estado', estado);
            formData.append('productos', productosPedidoJSON);
            formData.append('total', totalPriceWithDiscount);
            formData.append('nombre', name);
            formData.append('nota', noteText);
            formData.append('codigo', codigo);
            formData.append('origen', mesaActivaCliente ? 'qr' : 'mesero');
            formData.append('tipoEntrega', 'mesa');
            formData.append('metodoPago', 'efectivo');
            formData.append('estadoPago', 'pendiente');
            const response = await fetch(`${baseURL}/pedidoPost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();
            if (data.mensaje) {
                setMensaje('');
                Swal.fire(
                    'Pedido enviado!',
                    data.mensaje,
                    'success'
                );
                setName('');
                setCodigo('');
                setNoteText('');
                cargarMesas();
                closeModal();
                closeModal2();
                closeModal3();
                clearCart();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error, { autoClose: 1000 });
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.', { autoClose: 1000 });
        }
    };

    const isPaused = false;
    useEffect(() => {
        const interval = setInterval(() => {
            if (!isPaused) {
                cargarMesas();
            }
        }, (contador || 30) * 1000);

        return () => clearInterval(interval);
    }, [isPaused]);

    return (
        <div>
            <ToastContainer />
            <button onClick={openModal} className='cartIconFixed' title="Abrir carrito de compras">
                {
                    cartItems?.length >= 1 && (
                        <span>{cartItems.length}</span>
                    )
                }
                <FontAwesomeIcon icon={faShoppingCart} />
            </button>

            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
            >
                <div className='deFLex'>
                    <button onClick={closeModal}><FontAwesomeIcon icon={faArrowLeft} />  </button>
                    <MiPedido />
                    <button onClick={clearCart} className='deleteToCart'>Vaciar carrito</button>
                </div>
                {cartItems?.length === 0 ?
                    (<p className='nohay'> No hay productos</p>)
                    : (<>
                        <div className="modal-content-cart">
                            {loading ? (
                                <p>Cargando...</p>
                            ) : (
                                <div>
                                    {cartItems.map((item, index) => (
                                        <div key={item?.idProducto || index} className='cardProductCart' >
                                            <Anchor to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                                <img src={obtenerImagen(item)} alt="imagen" />
                                            </Anchor>
                                            <div className='cardProductCartText'>
                                                <h3>{item.titulo}</h3>
                                                <span>
                                                    {Array.isArray(item?.item) ? item?.item?.map((sabor, idx) => (
                                                        <span key={idx}> {sabor}</span>
                                                    )) : item?.item}
                                                </span>
                                                <strong>{moneda} {item?.precio}</strong>
                                            </div>
                                            <div className='deColumn'>
                                                <button onClick={() => removeFromCart(item.idProducto)} className='deleteCart'>  <FontAwesomeIcon icon={faTrash} /></button>
                                                <div className='deFlexCantidad'>
                                                    <button onClick={() => decreaseQuantity(index)}>-</button>
                                                    <span>{item.cantidad}</span>
                                                    <button onClick={() => increaseQuantity(index)}>+</button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className='deColumnCart'>
                            <h4>Total: {moneda} {totalPrice.toFixed(2)}</h4>
                            <div className='deFLexBtns'>
                                <button className='btnWpp' onClick={openModal2}>
                                    Pedir por <img src={whatsappIcon} alt="WhatsApp" />
                                </button>
                                <button className='btn' onClick={openModal3}>
                                    Pedí en tu mesa
                                </button>
                            </div>
                        </div>

                        <Modal
                            isOpen={modalIsOpen2}
                            onRequestClose={closeModal2}
                            className="modal-cart"
                            overlayClassName="overlay-cart"
                        >
                            <div className='deFLex'>
                                <button onClick={closeModal2}><FontAwesomeIcon icon={faArrowLeft} />  </button>
                                <h4>Agregar Detalles</h4>
                            </div>
                            <div className="modal-send-form">
                                <input
                                    type="text"
                                    id="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder='Nombre (opcional)'
                                />

                                <div className='deFLexRadio'>
                                    <label>Opciones de entrega</label>
                                    <div>
                                        <input
                                            type="radio"
                                            id="delivery"
                                            name="deliveryOption"
                                            value="delivery"
                                            checked={deliveryOption === 'delivery'}
                                            onChange={() => setDeliveryOption('delivery')}
                                        />
                                        <label htmlFor="delivery">Envío a domicilio</label>
                                    </div>
                                    <div>
                                        <input
                                            type="radio"
                                            id="pickup"
                                            name="deliveryOption"
                                            value="pickup"
                                            checked={deliveryOption === 'pickup'}
                                            onChange={() => setDeliveryOption('pickup')}
                                        />
                                        <label htmlFor="pickup">Retirar personalmente</label>
                                    </div>
                                </div>

                                <div className='deFLexRadio'>
                                    <label>Formas de pago</label>
                                    <div>
                                        <input
                                            type="radio"
                                            id="efectivo"
                                            name="paymentMethod"
                                            value="efectivo"
                                            checked={paymentMethod === 'efectivo'}
                                            onChange={() => setPaymentMethod('efectivo')}
                                        />
                                        <label htmlFor="efectivo">Efectivo</label>
                                    </div>
                                    <div>
                                        <input
                                            type="radio"
                                            id="transferencia"
                                            name="paymentMethod"
                                            value="transferencia"
                                            checked={paymentMethod === 'transferencia'}
                                            onChange={() => setPaymentMethod('transferencia')}
                                        />
                                        <label htmlFor="transferencia">Transferencia</label>
                                    </div>
                                </div>
                                <input
                                    type="text"
                                    id="codigo"
                                    value={codigo}
                                    onChange={(e) => setCodigo(e.target.value)}
                                    placeholder='Cupón de descuento (opcional)'
                                />
                                <textarea
                                    placeholder="Agrega una nota (opcional)"
                                    value={noteText}
                                    onChange={(e) => setNoteText(e.target.value)}
                                />
                                <button onClick={handleWhatsappMessage} className='btn'>Enviar</button>
                            </div>
                        </Modal>

                        <Modal
                            isOpen={modalIsOpen3}
                            onRequestClose={closeModal3}
                            className="modal-cart"
                            overlayClassName="overlay-cart"
                        >
                            <div className='deFLex'>
                                <button onClick={closeModal3}><FontAwesomeIcon icon={faArrowLeft} />  </button>
                                <h4>Elige tu mesa</h4>
                            </div>
                            <div className="modal-send-form">
                                <input
                                    type="text"
                                    id="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder='Nombre'
                                />
                                <input
                                    type="text"
                                    id="codigo"
                                    value={codigo}
                                    onChange={(e) => setCodigo(e.target.value)}
                                    placeholder='Cupón de descuento (opcional)'
                                />
                                <textarea
                                    placeholder="Agrega una nota (opcional)"
                                    value={noteText}
                                    onChange={(e) => setNoteText(e.target.value)}
                                />
                                {mesaActivaCliente ? (
                                    <div style={{
                                        background: '#ecfdf5',
                                        border: '2px solid #10b981',
                                        borderRadius: '10px',
                                        padding: '14px',
                                        textAlign: 'center',
                                        margin: '10px 0'
                                    }}>
                                        <p style={{ margin: 0, color: '#065f46', fontSize: '13px' }}>Mesa asignada por Código QR:</p>
                                        <h3 style={{ margin: '4px 0', color: '#047857', fontSize: '20px' }}>🍽️ {mesaActivaCliente.mesa}</h3>
                                        <span style={{ fontSize: '12px', color: '#059669' }}>Tu pedido se enviará directamente a la cocina con esta mesa</span>
                                    </div>
                                ) : (
                                    <div className='mesasGrapCart'>
                                        {mesas.map(item => (
                                            <div
                                                key={item.idMesa}
                                                className={`mesaCard ${item.estado === 'libre' ? (selectedMesa === item.idMesa ? 'selectedMesa' : 'bg-green') : 'bg-red'}`}
                                                onClick={() => { if (item.estado === 'libre') setIdMesa(item.idMesa); }}
                                            >
                                                <label>
                                                    {item.mesa}
                                                </label>
                                                <span>
                                                    {item.estado === 'libre' ? (selectedMesa === item.idMesa ? 'selectedMesa' : '') : 'ocupada'}
                                                </span>
                                                {item.estado === 'libre' && (
                                                    <input
                                                        type='radio'
                                                        name='productos'
                                                        value={item.idMesa}
                                                        readOnly
                                                        checked={idMesa === item.idMesa}
                                                    />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}

                                <fieldset className='deNonefieldset'>
                                    <legend>Productos</legend>
                                    <textarea
                                        name='productos'
                                        value={cartItems.map(item => ` ${item.categoria}, ${item.titulo}, x ${item.cantidad}, ${item.item},${item.categoria},${item.precio}, ${obtenerImagen(item)}  `).join('\n')}
                                        readOnly
                                    />
                                </fieldset>
                                {mensaje ? (
                                    <button type='button' className='btn' disabled>
                                        {mensaje}
                                    </button>
                                ) : (
                                    <button type='button' onClick={crearPedido} className='btn'>
                                        Finalizar pedido
                                    </button>
                                )}
                            </div>
                        </Modal>
                    </>)}
            </Modal>
        </div>
    );
}
